import { Routes, RouterModule } from "@angular/router";
import { AdminComponent } from "./index";
import { GuardianNotificationRegComponent } from "./guardiannotificationregistration/guardiannotificationreg.component";
import { BarcodeComponent } from "./barcode/barcode.component";
import { MealAssignmentComponent } from "./mealassignment/mealassignment.component";
import { ViewApplicationLogsComponent } from "./view-application-logs/view-application-logs.component";
import { BatchAttendanceComponent } from "./batchattendance/batchattendance.component";
import { TriggersComponent } from "./triggers/triggers.component";
import { ZeroOutAccountsComponent } from "./zero-out-accounts/zero-out-accounts.component";
import { SchoolIncidentSetupComponent } from "./school-incident-setup/school-incident-setup.component";
import { GuardianNotificationBatchComponent } from "./guardian-notification-batch/guardian-notification-batch.component";
import { ApplicationSetupComponent } from "./application-setup/application-setup.component";
import { SubstitutionMaintenanceComponent } from "./substitution-maintenance/substitution-maintenance.component";
import { AuthguardService } from "../master/services";

export const AdminRoutes: Routes = [
	{ path: "", redirectTo: "/admin/barcode", pathMatch: "full" },
	{
		path: "barcode",
		data: { title: "Barcode Management" },
		component: BarcodeComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "mealassignment",
		data: { title: "Meal Assignments" },
		component: MealAssignmentComponent,
		canActivate: [AuthguardService],
	},

	// { path: "application", data: { title: "Application Maintenance (SU Only)" }, component: ApplicationComponent }, //Old
	{
		path: "application",
		data: { title: "Application Maintenance (SU Only)" },
		component: ApplicationSetupComponent,
		canActivate: [AuthguardService],
	}, //New

	{
		path: "notifyreg",
		data: { title: "Guardian Notification Registration" },
		component: GuardianNotificationRegComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "notifyregbatch",
		data: { title: "Guardian Notification Batch Registration" },
		component: GuardianNotificationBatchComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "notifyguard",
		data: { title: "Guardian Notifications" },
		component: BarcodeComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "viewlog",
		data: { title: "View Application Logs (SU Only)" },
		component: ViewApplicationLogsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "schoolincident",
		data: { title: "School Incident" },
		component: SchoolIncidentSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "substitute",
		data: { title: "Substitute Administration" },
		component: SubstitutionMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "batchattendance",
		data: { title: "Batch Attendance" },
		component: BatchAttendanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "actiontrigger",
		data: { title: "Action Triggers" },
		component: TriggersComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "zerooutfinemeal",
		data: { title: "Zero Out Accounts" },
		component: ZeroOutAccountsComponent,
		canActivate: [AuthguardService],
	},
];
